
import {writable} from 'svelte/store';

const store = writable([]);

store.getAll = async (appId, filter = '') => {
    const res = await fetch(`api/v1/members/${appId}?filter=${filter}`);
    const members = await res.json();
    if(res.ok) {
        store.set(members);
    } else {
        store.set([]);
    }
}

store.delete = async (appId, user) => {
    const res = await fetch(`api/v1/members/${appId}/${user}`, {
          method: 'DELETE'
      });
      const body = await res.json();
      if(res.ok) { 
        store.update(data => {
            return data.filter(member => member.user != user);
        });
      };
      return {ok: res.ok, body};
}

store.post = async (member) => {
    const res = await fetch(`api/v1/members/${member.appId}`, {
        method: 'POST', 
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(member)
    });
    const body = await res.json();
    if(res.ok) {
        store.update(data => {
            const newMember = body.filter(newMember => newMember.user === member.user);
            const newData = [...newMember, ...data];
            return newData;
        });
    }
    return {ok: res.ok, body};
}

export default store;
